<section id="main-container">

    <div id="main" class="col-xs-12">
        <app-breadcrumb currentPage="Meu Desempenho" routerCurrentPage="/meu-desempenho"></app-breadcrumb>

        <!-- PERFIL -->
        <div id="profile" class="row">

            <!-- ABAs -->

            <div class="row profile-infos text-center">
                <!-- Nav tabs -->
                <ul class="nav nav-tabs" role="tablist">
                    <li class="active">
                        <a href="#performance" aria-controls="performance" role="tab" data-toggle="tab" title="Meu desempenho">Meu Desempenho</a>
                    </li>
                    <li *ngIf="!hasLeads">
                        <a href="#ranking" aria-controls="ranking" role="tab" data-toggle="tab" title="Ranking">Ranking</a>
                    </li>
                </ul>
            </div>


            <div class="col-md-10 col-md-offset-1 text-center">
                <div class="tab-content">
                    <app-meu-desempenho role="tabpanel" class="tab-pane active" id="performance"></app-meu-desempenho>
                    <app-ranking role="tabpanel" class="tab-pane" id="ranking"></app-ranking>
                </div>
            </div>
        </div>
    </div>
    <!-- PERFIL End -->
</section>